module.exports = __webpack_public_path__ + "img/caret.80313fa8.svg";